export default "__VITE_ASSET__CGndb0g5__"